import { SET_SICK_NOTE, SET_SCHOOL_WORK_FORM } from '../actions/type';

const initialState = {
  data: {
    timeOffIsFor: '',
    timeOffReason: '',
    startTimeOff: null,
    endOfTimeOff: null,
    isAgreed: false,
    // Fields for school-work-form
    formType: 'sick-note',
    organization: ''
  }
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_SICK_NOTE:
    case SET_SCHOOL_WORK_FORM:
      return {
        ...state,
        data: payload
      };
    default:
      return state;
  }
}
